import { useTranslate } from "src/i18n";

export const useProductPriceStatusTranslate = () => {
  const { t } = useTranslate();

  return {
    this_platform: t("product_price_status.this_platform", "этой площадки"),
    load_failed: (platform: string) =>
      t(
        "product_price_status.load_failed",
        "Не удалось загрузить цены с {platform}",
        { platform },
      ),
    load_failed_hint: t(
      "product_price_status.load_failed_hint",
      "Площадка не ответила. Повторите запрос или выберите другую.",
    ),
    no_prices: (platform: string) =>
      t("product_price_status.no_prices", "Цен с {platform} нет", { platform }),
    no_prices_hint: t(
      "product_price_status.no_prices_hint",
      "Площадка не отдала цены по этому товару. Выберите другую.",
    ),
    retry: t("product_price_status.retry", "Повторить"),
  };
};
